"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Column = void 0;
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const styles_1 = require("@material-ui/core/styles");
const useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
const Column_1 = __importDefault(require("./components/Column"));
exports.Column = Column_1.default;
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        width: '100%',
        '& hr': {
            margin: theme.spacing(0, 2),
        },
        marginTop: -theme.spacing(1),
        '&>*': {
            marginTop: theme.spacing(1),
        },
    },
    column: {
        overflow: 'hidden',
    },
}));
const covertBreakpoint = (breakpoint) => {
    const breakpoints = {
        lg: 3,
        md: 2,
        sm: 1,
    };
    return breakpoints[breakpoint] || 0;
};
const getBreakpointValue = (collapseBelow, breakpoint) => {
    return covertBreakpoint(collapseBelow) - covertBreakpoint(breakpoint) >= 0 ? 12 : true;
};
/**
 * The column layout is a helper component to ease the layout process.
 * Within containers, users can position their content in typical layouts, for example: two columns in a row.
 */
const ColumnLayout = ({ children, renderDivider = true, collapseBelow = 'xs', }) => {
    const classes = useStyles();
    const theme = styles_1.useTheme();
    const matched = useMediaQuery_1.default(theme.breakpoints.up(collapseBelow));
    const columns = react_1.Children.toArray(children);
    return (react_1.default.createElement(Grid_1.default, { container: true, justify: "flex-start", alignItems: "flex-start", className: classes.root }, columns.map((column, index) => (react_1.default.createElement(react_1.Fragment, { key: `column${index}` },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: getBreakpointValue(collapseBelow, 'sm'), md: getBreakpointValue(collapseBelow, 'md'), lg: getBreakpointValue(collapseBelow, 'lg'), xl: true, className: classes.column }, column),
        index !== columns.length - 1 && renderDivider && matched && (react_1.default.createElement(Divider_1.default, { orientation: "vertical", flexItem: true })))))));
};
exports.default = ColumnLayout;
//# sourceMappingURL=index.js.map